import axios from 'axios'

export default {
    GETSEARCHRESULTS ({ commit }, query) {
        return axios.get(`/search/searchVideoContent/${query[0]}/null/200/${query[1]}`).then((response) => {
            const { data: { data } } = response
            commit('setSearchResults', {results: data.videos})
            commit('setSearchExpertResults', {results: data.events})
            commit('setSearchPlaylistResults', {results: data.playlists})
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETSEARCHRESULTS_POST ({ commit }, query) {
        return axios.post(`/search/searchVideoContent`, query).then((response) => {
            const { data: { data } } = response
            commit('setSearchResults', {results: data.videos})
            commit('setSearchExpertResults', {results: data.events})
            commit('setSearchPlaylistResults', {results: data.playlists})
        }, (err) => {
            console.log('err ', err)
        })
    },
    SORTDATA ({ commit }, query) {
        console.log(query)
        const searchObject = query
        return axios.post(`/search/searchVideoContent`, searchObject).then((response) => {
            console.log(response)
            const { data: { data } } = response
            commit('setSearchExpertResults', {results: data.events})
            commit('setSearchPlaylistResults', {results: data.playlists})
            commit('setSearchResults', {results: data.videos})
        })
    }
}




// WEBPACK FOOTER //
// ./src/store/search/actions.js